export default __webpack_public_path__ + "static/media/logo.310ac71e.svg";